// extracted by mini-css-extract-plugin
export default {"content":"PatientContent_content__he39N"};